import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption } from '../modules/tcm-core.module';
import { PatientEmailTemplateResponse } from '../models/patients';

@Injectable({
  providedIn: 'root'
})
export class EmailTemplateDataService {
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public sendEmailTemplateAsync(email: string, documentTemplateId: number, patientId: number, clinicId: number, cancellationToken: Promise<any>): Promise<boolean> {
    const request = { email, documentTemplateId, patientId, clinicId };
    return this.httpClient.postJsonAsync<boolean>('Patients/SendEmail', request, cancellationToken);
  }

  public getEmailTemplateRenderAsync(documentTemplateId: any, patientId: number, cancellationToken: Promise<any>): Promise<PatientEmailTemplateResponse> {
    const request = { documentTemplateId, patientId };
    return this.httpClient.getJsonAsync<PatientEmailTemplateResponse>('Patients/RenderEmail', request, cancellationToken);
  }

  public getEmailTemplateOptionsAllAsync(cancellationToken: Promise<any>): Promise<ListOption<number>[]> {
    return this.httpClient.getJsonAsync<ListOption<number>[]>('DocumentTemplates/EmailOptionsAll', {}, cancellationToken);
  }
}
